import { Instagram, Mail, ArrowUpRight, MessageCircle } from "lucide-react";
import ContactLinks from "./ContactLinks";
import { Reveal, Eyebrow } from "./Reveal";

export default function Contact({ content }) {
  return (
    <section id="contact" className="bg-umber text-cream">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-10">
        <Reveal>
          <Eyebrow light>Get In Touch</Eyebrow>
          <h2 className="mt-8 max-w-3xl font-serif text-4xl leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
            Let's paint <em className="text-gild">your</em> story.
          </h2>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-cream/70 sm:text-lg">
            Originals, commissions, and custom paintings made from your photographs — share your
            idea, a memory, or a photograph, and receive a hand-painted piece of your own.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-14">
            <ContactLinks whatsapp={content?.whatsapp} instagram={content?.instagram} email={content?.email} />
          </div>
        </Reveal>

        <Reveal delay={0.18}>
          <div
            data-testid="availability-legend"
            className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 font-mono text-[10px] uppercase tracking-[0.22em] text-cream/60"
          >
            <span className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full bg-green-500" data-testid="legend-available-dot" />
              Available for sale
            </span>
            <span className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full bg-red-500" data-testid="legend-sold-dot" />
              Sold out
            </span>
          </div>
        </Reveal>

        <div className="mt-24 flex flex-col justify-between gap-4 border-t border-cream/10 pt-8 sm:flex-row sm:items-center">
          <div className="font-serif text-lg italic leading-relaxed text-cream/80">
            <p>
              Artwith<span className="text-gild">.saivi</span> — Saivi Rahul Joshi
            </p>
            <p>
              Artwith<span className="text-gild">.saloni</span> — Salonee Rahul Joshi
            </p>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-cream/40">
            © 2026 · Prices in INR (India)
          </p>
          <a
            data-testid="footer-owner-login-link"
            href="/admin"
            className="font-mono text-[10px] uppercase tracking-[0.24em] text-cream/40 transition-colors hover:text-gild"
          >
            Owner Login
          </a>
        </div>
      </div>
    </section>
  );
}
